/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SearchMusicResourcesRequest} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/music.pb'
import {SearchMusicResourcesResponse} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/music.pb'


export const searchMusicResources = (request: SearchMusicResourcesRequest, options?: CashRequestOptions) => post<SearchMusicResourcesRequest, SearchMusicResourcesResponse>("/2.0/cash/search-music-resources", request, {...options, rejectOnError: true })